import { isThursday } from 'date-fns';

export default {
  data() {
    return {
      loaded: false,

    };
  },
  created() {
    const scrollWidth = window.innerWidth - document.documentElement.clientWidth;
    document.body.style.overflow = 'hidden';
    document.body.style.paddingRight = `${scrollWidth}px`;
    const escapeHandler = (e) => {
      if (e.key === 'Escape') {
        this.dismiss();
      }
    };
    document.addEventListener('keydown', escapeHandler);
    this.$once('hook:destroyed', () => {
      document.removeEventListener('keydown', escapeHandler);
      this.dismiss();
    });
  },
  methods: {
    dismiss() {
      document.body.style.overflow = 'auto';
      document.body.style.paddingRight = '';
      this.$emit('close');
    },
    close() {
      this.$emit('close');
    },
  },
};
